import { AlertOctagon, AlertTriangle, Hourglass, Layers, Receipt } from "lucide-react";

function Tile({ icon: Icon, label, value, tone, testid }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid={testid}>
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-slate-500"><Icon className={`w-4 h-4 ${tone}`} />{label}</div>
      <div className="mt-1 text-2xl font-display font-semibold text-slate-900 tabular-nums">{value}</div>
    </div>
  );
}

export default function OwnerSummary({ data }) {
  if (!data) return null;
  const t = data.tenants;
  const n = (fn) => t.filter(fn).length;
  const billable = t.reduce((a, x) => a + (x.billable_overage || 0), 0);
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="licenses-summary">
      <Tile icon={AlertOctagon} tone="text-rose-500" label="Blocked" value={n((x) => x.state === "blocked" || x.state === "trial_ended")} testid="licenses-summary-blocked" />
      <Tile icon={AlertTriangle} tone="text-amber-500" label="Grace / 80%+" value={n((x) => x.state === "grace" || x.state === "warning")} testid="licenses-summary-attention" />
      <Tile icon={Hourglass} tone="text-indigo-500" label="On trial" value={n((x) => x.plan?.key === "trial")} testid="licenses-summary-trials" />
      <Tile icon={Layers} tone="text-indigo-500" label="Interviews this month" value={t.reduce((a, x) => a + (x.used || 0), 0)} testid="licenses-summary-used" />
      <Tile icon={Receipt} tone="text-emerald-600" label="Extra this month" value={`${t.reduce((a, x) => a + (x.overage || 0), 0)}${billable ? ` · $${Math.round(billable)}` : ""}`} testid="licenses-summary-overage" />
    </div>
  );
}
